module.exports = __webpack_public_path__ + "static/CardTemplates-c1078aa44265d7185e779c4add32b5a0.png";